import { ADD_ENTITIES } from "../actions/actions";
import { mergeEntitiesWithState, panelProfil } from "../helpers/schema";

const schema = panelProfil;

export function panelProfils(
  state = {
    all: {},
  },
  action
) {
  switch (action.type) {
    case ADD_ENTITIES:
      let data = action.payload.panelProfil;
      if (!data) return state;

      return {
        ...state,
        all: mergeEntitiesWithState(data, state.all, schema),
      };
    default:
      return state;
  }
}
